// Silent activity tracker — used to build the monthly admin recap.
// Fire-and-forget : never blocks the UI, never throws.

import { api } from "@/lib/api";

/**
 * Log a "client_view" activity. Called when a non-admin user opens a client
 * detail page (/clients/:id).
 *
 * Skipped for admin (no recap needed for the admin themselves).
 */
export function logClientView(user, client) {
  if (!user || (user.role || "").toLowerCase() === "admin") return;
  try {
    api
      .post("/activity/log", {
        username: user.username,
        role: user.role,
        action: "client_view",
        target_id: client?.id || null,
        target_label: client
          ? [client.nom, client.prenom].filter(Boolean).join(" ")
          : null,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      })
      .catch((e) => {
        // Fire-and-forget telemetry — log but never bubble up to the UI.
        console.warn("[activity] log send failed", e?.message);
      });
  } catch (e) {
    console.warn("[activity] log builder failed", e?.message);
  }
}
